module.exports = __webpack_public_path__ + "img/2_2-finanziario-stazione-0.a47ea537.png";